/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import { JsonObject } from '@superset-ui/core';
import { areObjectsEqual } from '../../../reduxUtils';

export const arrayDiff = (a: string[], b: string[]) => [
  ...a.filter(x => !b.includes(x)),
  ...b.filter(x => !a.includes(x)),
];

export const getAffectedOwnDataCharts = (
  ownDataCharts: JsonObject,
  appliedOwnDataCharts: JsonObject,
) => {
  const chartIds = Object.keys(ownDataCharts);
  const appliedChartIds = Object.keys(appliedOwnDataCharts);
  const affectedIds: string[] = arrayDiff(chartIds, appliedChartIds).filter(
    id => ownDataCharts[id] || appliedOwnDataCharts[id],
  );
  const checkForUpdateIds = new Set<string>([...chartIds, ...appliedChartIds]);
  checkForUpdateIds.forEach(chartId => {
    if (
      !areObjectsEqual(ownDataCharts[chartId], appliedOwnDataCharts[chartId])
    ) {
      affectedIds.push(chartId);
    }
  });
  return [...new Set(affectedIds)];
};
